import { connect } from 'react-redux'

import DataCorrectionPage from '../components/DataCorrectionPage'
import { actions } from '../modules/DataCorrection'

const mapStateToProps = ({ dataCorrection, loading }, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  return {
    dataCorrection,
    loading: loading.general,
    studyVersionID,
  }
}

const mapDispatchToProps = { ...actions }

export default connect(mapStateToProps, mapDispatchToProps)(DataCorrectionPage)
